import React from "react";
import "./Footer.css";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import logo from "./logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-col logo-col">
            <div className="footer-logo">
              <div className="footer-taxi-animation">
                <img src={logo} alt="logo"></img>
              </div>
              <h2>
                Waheguru<span>Cabs</span>
              </h2>
            </div>
            <p className="footer-description">
              Your trusted partner for safe and comfortable rides across the
              city. Available 24/7 for all your transportation needs.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/" target="_blank" className="social-icon">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/" target="_blank" className="social-icon">
                <FaInstagram />
              </a>
              {/* <a href="" className="social-icon">
                <FaWhatsapp />
              </a> */}
              <a href="https://www.youtube.com/" target="_blank" className="social-icon">
                <FaYoutube />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/home">
                  <i className="fas fa-chevron-right"></i> Home
                </a>
              </li>
              <li>
                <a href="/book-ride">
                  <i className="fas fa-chevron-right"></i> Book Ride
                </a>
              </li>
              <li>
                <a href="/blogs-gallery">
                  <i className="fas fa-chevron-right"></i> Blogs/Gallery
                </a>
              </li>
              <li>
                <a href="/about-us">
                  <i className="fas fa-chevron-right"></i> About Us
                </a>
              </li>
              <li>
                <a href="/contact">
                  <i className="fas fa-chevron-right"></i> Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              <li>
                <a href="#">
                  <i className="fas fa-chevron-right"></i> City Rides
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fas fa-chevron-right"></i> Airport Transfer
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fas fa-chevron-right"></i> Hourly Rental
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fas fa-chevron-right"></i> Corporate Rides
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fas fa-chevron-right"></i> Special Events
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
               <i className="fas fa-phone"><IoLocationSharp />
</i>
                <p>
                  Shop No.4, Nyati Complex, Besides, Bikaner Sweets,
                  Osmanpura,Chh. Sambhajinagar (MH) - 431005
                </p>
              </li>
              <li>
                <i className="fas fa-phone"><FaPhoneSquareAlt /></i>+91 9764482121
              </li>
               <li>
                <i className="fas fa-phone"><FaPhoneSquareAlt /></i>+91 9765007100
              </li>
              <li>
                <i className="fas fa-envelope"><MdEmail /></i> booking@wahegurucabs.com
                
              </li>
              <li><i className="fas fa-envelope"><MdEmail /></i> support@wahegurucabs.com</li>
            </ul>
            {/* <div className="footer-app">
              <h4>Download Our App</h4>
              <div className="app-buttons">
                <a href="#" className="app-btn">
                  <i className="fab fa-google-play"></i>
                  <span>Google Play</span>
                </a>
                <a href="#" className="app-btn">
                  <i className="fab fa-apple"></i>
                  <span>App Store</span>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">
            &copy; {new Date().getFullYear()} Waheguru Cabs All Rights Reserved
            | Designed & Powered by MK e-Tech Private Limited
          </p>
        </div>
      </div>

      <div className="moving-taxi">
        <div className="taxi-car">
          <div className="taxi-top"></div>
          <div className="taxi-body">
            <div className="window"></div>
            <div className="light"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
